var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center"},[_c('img',{attrs:{"src":_vm.source.angry}}),_c('img',{attrs:{"src":_vm.source.love}})])}
var staticRenderFns = []

export { render, staticRenderFns }